<template>
  <div style>
    <el-card class="box-card">
      <div>
        <div class="item">微信昵称：{{nickname?nickname:"尚未绑定微信"}}</div>
        <div v-if="nickname" class="item center">
          <el-button type="primary" @click="unbindWechat">取消绑定</el-button>
        </div>
        <div v-else class="item center">
          <el-button type="primary" @click="bindWechat">绑定微信</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      nickname: null
    };
  },
  created: function() {
    if (this.$route.query.code) {
      this.api.staff
        .bindWechat({ code: this.$route.query.code })
        .then(response => {
          if (!response.data.errorCode) {
            this.updateBindInfo();
          }
        });
    }
    this.updateBindInfo();
  },
  methods: {
    updateBindInfo: function() {
      this.api.staff.getWechatAuth({}).then(response => {
        if (!response.data.errorCode) {
          if (response.data.data) {
            this.nickname = response.data.data.nickname;
          } else {
            this.nickname = null;
          }
        }
      });
    },
    bindWechat: function() {
      this.api.staff
        .getWxMpBindUrl({
          redirectUri: location.origin + `/staff/wx/mp/bind/code`
        })
        .then(response => {
          if (!response.data.errorCode && response.data.data != null) {
            location.href = response.data.data;
          }
        });
    },
    unbindWechat: function() {
      this.api.staff.unbindWechat({}).then(response => {
        if (!response.data.errorCode) {
          this.updateBindInfo();
        }
      });
    }
  }
};
</script>
<style scoped>
.item {
  padding: 15px;
  font-size: 14px;
}
.center {
  text-align: center;
  padding: 30px;
}
</style>


// WEBPACK FOOTER //
// wechat.vue?740a53c8